export default {
  mounted(el, binding) {
    handler(el, binding)
  },
  updated(el, binding) {
    handler(el, binding)
  },
}

const handler = (el, binding) => {
  const areChildrenEditable = binding.value === true
  el.querySelectorAll('[contenteditable]').forEach(el => {
    if (areChildrenEditable) {
      el.setAttribute('contenteditable', 'true')
    } else {
      el.setAttribute('contenteditable', 'false')
    }
  })
}
